import { type QueryHookOptions, useQuery } from "@apollo/client";
import PlatformsSearchAutocompleteQuery from "../graphql/queries/PlatformsSearchAutocompleteQuery.graphql";
import type {
  PlatformsSearchAutocompleteQueryType,
  PlatformsSearchAutocompleteQueryVariablesType,
} from "@/types/graphql/admin.generated";

export const usePlatformsAutocompleteQuery = (
  options?: QueryHookOptions<
    PlatformsSearchAutocompleteQueryType,
    PlatformsSearchAutocompleteQueryVariablesType
  >
) => {
  return useQuery<
    PlatformsSearchAutocompleteQueryType,
    PlatformsSearchAutocompleteQueryVariablesType
  >(PlatformsSearchAutocompleteQuery, options);
};
